<template>
    <guest-layout>
        <div class="form-col mh-100">
            <div class="arrow-back d-none d-lg-block">
                <a :href="route('login')"><span><i class="feather-chevron-left"></i></span>Back to login</a>
            </div>
            <div class="web-form step-form">
                <div class="title-col regTitle">
                    <h2>Create an Account</h2>
                    <p>Type in your details to sign up. Once you sign up you start with a free plan.</p>
                </div>
                <form class="form-style">
                    <div>
                        <div class="form-group">
                            <a :href="route('register')" class="btn btn-style btn-secondary w-100 btn-r-font">
                                <span>Sign up with Email</span>
                            </a>
                        </div>

                        <div class="form-group">
                            <a :href="route('auth.sso', {provider: 'github'})" class="btn btn-style btn-secondary w-100 btn-r-font">
                                <span>Sign up with Github</span>
                            </a>
                        </div>

                        <div class="form-group">
                            <a :href="route('auth.sso', {provider: 'google'})" class="btn btn-style btn-secondary w-100 btn-r-font">
                                <span>Sign up with Google</span>
                            </a>
                        </div>
                    </div>
                    <div class="form-group reg-form-group">
                        <div class="login-content text-center">
                            <!-- <span>Already have an account? <a href="login-first-step.html">Login</a></span> -->
                            Already have an account?
                            <inertia-link :href="route('login')" class="underline text-sm text-gray-600 hover:text-gray-900">
                                Login here
                            </inertia-link>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </guest-layout>
</template>

<script>
    import GuestLayout from "@/Layouts/GuestLayout";

    export default {
        name: "RegisterProviders",

        components: {
            GuestLayout,
        },
    }
</script>

<style scoped>

</style>
